/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AmountDecimal,
  AmountDecimal$inboundSchema,
  AmountDecimal$Outbound,
  AmountDecimal$outboundSchema,
} from "./amountdecimal.js";
import {
  ScheduledTransferImageMetadata,
  ScheduledTransferImageMetadata$inboundSchema,
  ScheduledTransferImageMetadata$Outbound,
  ScheduledTransferImageMetadata$outboundSchema,
} from "./scheduledtransferimagemetadata.js";
import {
  ScheduledTransferLineItemOption,
  ScheduledTransferLineItemOption$inboundSchema,
  ScheduledTransferLineItemOption$Outbound,
  ScheduledTransferLineItemOption$outboundSchema,
} from "./scheduledtransferlineitemoption.js";

/**
 * Represents a single item in a scheduled transfer, including optional modifiers and quantity.
 */
export type ScheduledTransferLineItem = {
  /**
   * The name of the item.
   */
  name: string;
  /**
   * The base price of the item before applying option modifiers.
   */
  basePrice: AmountDecimal;
  /**
   * The quantity of this item.
   */
  quantity: number;
  /**
   * Optional list of modifiers applied to this item (e.g., toppings, upgrades, customizations).
   */
  options?: Array<ScheduledTransferLineItemOption> | undefined;
  /**
   * Optional unique identifier associating the line item with a product.
   */
  productID?: string | undefined;
  /**
   * Optional list of images associated with this line item.
   */
  images?: Array<ScheduledTransferImageMetadata> | undefined;
};

/** @internal */
export const ScheduledTransferLineItem$inboundSchema: z.ZodType<
  ScheduledTransferLineItem,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  basePrice: AmountDecimal$inboundSchema,
  quantity: z.number().int(),
  options: z.array(ScheduledTransferLineItemOption$inboundSchema).optional(),
  productID: z.string().optional(),
  images: z.array(ScheduledTransferImageMetadata$inboundSchema).optional(),
});
/** @internal */
export type ScheduledTransferLineItem$Outbound = {
  name: string;
  basePrice: AmountDecimal$Outbound;
  quantity: number;
  options?: Array<ScheduledTransferLineItemOption$Outbound> | undefined;
  productID?: string | undefined;
  images?: Array<ScheduledTransferImageMetadata$Outbound> | undefined;
};

/** @internal */
export const ScheduledTransferLineItem$outboundSchema: z.ZodType<
  ScheduledTransferLineItem$Outbound,
  z.ZodTypeDef,
  ScheduledTransferLineItem
> = z.object({
  name: z.string(),
  basePrice: AmountDecimal$outboundSchema,
  quantity: z.number().int(),
  options: z.array(ScheduledTransferLineItemOption$outboundSchema).optional(),
  productID: z.string().optional(),
  images: z.array(ScheduledTransferImageMetadata$outboundSchema).optional(),
});

export function scheduledTransferLineItemToJSON(
  scheduledTransferLineItem: ScheduledTransferLineItem,
): string {
  return JSON.stringify(
    ScheduledTransferLineItem$outboundSchema.parse(scheduledTransferLineItem),
  );
}
export function scheduledTransferLineItemFromJSON(
  jsonString: string,
): SafeParseResult<ScheduledTransferLineItem, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ScheduledTransferLineItem$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ScheduledTransferLineItem' from JSON`,
  );
}
